var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 28.3333L21.6673 31.6666C21.9956 31.9949 22.3854 32.2554 22.8143 32.433C23.2433 32.6107 23.703 32.7022 24.1673 32.7022C24.6316 32.7022 25.0914 32.6107 25.5203 32.433C25.9493 32.2554 26.339 31.9949 26.6673 31.6666C26.9956 31.3383 27.256 30.9486 27.4337 30.5196C27.6114 30.0907 27.7029 29.6309 27.7029 29.1666C27.7029 28.7023 27.6114 28.2426 27.4337 27.8136C27.256 27.3847 26.9956 26.9949 26.6673 26.6666",
    stroke: "url(#paint0_linear_623_3438)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3279 23.3333L27.4945 27.5C28.1576 28.163 29.0568 28.5355 29.9945 28.5355C30.9322 28.5355 31.8315 28.163 32.4945 27.5C33.1576 26.8369 33.5301 25.9377 33.5301 25C33.5301 24.0623 33.1576 23.163 32.4945 22.5L26.0279 16.0333C25.0903 15.097 23.8195 14.5711 22.4945 14.5711C21.1695 14.5711 19.8987 15.097 18.9612 16.0333L17.4945 17.5C16.8315 18.163 15.9322 18.5355 14.9945 18.5355C14.0568 18.5355 13.1576 18.163 12.4945 17.5C11.8315 16.8369 11.459 15.9377 11.459 15C11.459 14.0623 11.8315 13.163 12.4945 12.5L17.1779 7.81665C18.6983 6.30023 20.681 5.33424 22.8123 5.07161C24.9435 4.80897 27.1015 5.2647 28.9445 6.36665L29.7279 6.83332C30.4375 7.26163 31.2813 7.41018 32.0945 7.24998L34.9945 6.66665",
    stroke: "url(#paint1_linear_623_3438)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0007 5L36.6673 23.3333H33.334",
    stroke: "url(#paint2_linear_623_3438)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 5L3.33398 23.3333L14.1673 34.1667C14.8304 34.8297 15.7296 35.2022 16.6673 35.2022C17.605 35.2022 18.5043 34.8297 19.1673 34.1667C19.8304 33.5036 20.2029 32.6043 20.2029 31.6667C20.2029 30.729 19.8304 29.8297 19.1673 29.1667",
    stroke: "url(#paint3_linear_623_3438)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66663H18.3333",
    stroke: "url(#paint4_linear_623_3438)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3438",
    x1: 18.334,
    y1: 29.6844,
    x2: 27.7029,
    y2: 29.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3438",
    x1: 11.459,
    y1: 16.7673,
    x2: 34.9945,
    y2: 16.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3438",
    x1: 33.334,
    y1: 14.1667,
    x2: 36.6673,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_3438",
    x1: 3.33398,
    y1: 20.1011,
    x2: 20.2029,
    y2: 20.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_623_3438",
    x1: 5,
    y1: 7.16663,
    x2: 18.3333,
    y2: 7.16663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerManagement);
export default __webpack_public_path__ + "static/media/customer_management.9f07526ad32c008d409d3483491f17f5.svg";
export { ForwardRef as ReactComponent };